import React, { useState, useEffect } from 'react';
import { aboutUsAPI } from '../../api/services';
import { useTranslation } from 'react-i18next';

const IMAGES = [
  'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=600&q=80',
  'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=600&q=80',
  'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=600&q=80',
];

const AboutPage = () => {
  const [aboutList, setAboutList] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    aboutUsAPI.getAll()
      .then(r => setAboutList(r.data?.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <div className="page-header">
        <div className="container">
          <span className="section-label">{t('about.who_we_are')}</span>
          <h1>{t('about.title')}</h1>
          <p>{t('about.subtitle')}</p>
        </div>
      </div>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="container">
          {loading ? (
            <div className="loading"><div className="spinner"></div></div>
          ) : aboutList.length === 0 ? (
            <div style={{ maxWidth: 720, margin: '0 auto' }}>
              <div className="about-content">
                <div className="about-text">
                  <h2>{t('about.mission_title')}</h2>
                  <p>{t('about.mission_text')}</p>
                </div>
                <img src={IMAGES[0]} alt="Mission" className="about-image" />
              </div>
              <div className="about-content">
                <div className="about-text">
                  <h2>{t('about.vision_title')}</h2>
                  <p>{t('about.vision_text')}</p>
                </div>
                <img src={IMAGES[1]} alt="Vision" className="about-image" />
              </div>
            </div>
          ) : (
            <div>
              {aboutList.map((item, i) => (
                <div key={item.id} className="about-content">
                  <div className="about-text">
                    <h2>{item.title}</h2>
                    <p>{item.text}</p>
                  </div>
                  <img src={item.mediaUrl || IMAGES[i % IMAGES.length]} alt={item.title} className="about-image" />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default AboutPage;
